import React, { useEffect } from 'react';
import { Form, Input, Button, Select, InputNumber, message } from 'antd';

const layout = {
	labelCol: {
		span: 8,
	},
	wrapperCol: {
		span: 18,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 8,
		span: 16,
	},
};

const EditGenerationForm = ({
	makes,
	models,
	generation,
	features,
	utils,
	updateGeneration,
	setEditModal,
	setRefresh,
}) => {
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue(generation);
	}, [form, generation]);

	const onFinish = async (values) => {
		await updateGeneration(generation._id, values);
		setEditModal();
		setRefresh();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	return (
		<div>
			<Form {...layout} form={form} name="basic" onFinish={onFinish} onFinishFailed={onFinishFailed}>
				<Form.Item
					label="Make"
					name="make"
					rules={[{ required: true, message: 'Please select make!' }]}
					initialValue={generation?.make}
				>
					<Select showSearch allowClear={true} placeholder="Select a make">
						{makes.map((make) => (
							<Select.Option value={make._id} key={make._id}>
								{make._id}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item
					label="Model"
					name="model"
					rules={[{ required: true, message: 'Please select model!' }]}
					initialValue={generation?.model}
				>
					<Select showSearch allowClear={true} placeholder="Select a model">
						{models.map((model) => (
							<Select.Option value={model.name} key={model._id}>
								{model.name}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item
					label="Trim"
					name="name"
					rules={[{ required: true, message: 'Please input trim/variant!' }]}
					initialValue={generation?.name}
				>
					<Input />
				</Form.Item>
				<Form.Item
					label="Body Type"
					name="bodyType"
					rules={[{ required: true, message: 'Please select model!' }]}
					initialValue={generation?.bodyType}
				>
					<Select showSearch allowClear={true} placeholder="Select a body type">
						{utils?.bodyTypes.map((bodyType, index) => (
							<Select.Option value={bodyType._id} key={index}>
								{bodyType._id}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item
					label="Transmission"
					name="transmission"
					rules={[{ required: true, message: 'Please select transmission!' }]}
					initialValue={generation.transmission}
				>
					<Select showSearch allowClear={true} mode="multiple" placeholder="Select a transmission">
						<Select.Option value="automatic">Automatic</Select.Option>
						<Select.Option value="manual">Manual</Select.Option>
					</Select>
				</Form.Item>
				<Form.Item
					label="Features"
					name="features"
					rules={[{ required: true, message: 'Please select features!' }]}
					initialValue={generation?.features}
				>
					<Select showSearch allowClear={true} mode="multiple" placeholder="Select a features">
						{features?.map(
							(feature) =>
								feature._id === 'Car Features' &&
								feature.features.map((feat) => (
									<Select.Option value={feat} key={feat}>
										{feat}
									</Select.Option>
								))
						)}
					</Select>
				</Form.Item>
				<Form.Item
					label="Category"
					name="category"
					rules={[{ required: true, message: 'Please select category!' }]}
					initialValue={generation?.category}
				>
					<Select showSearch allowClear={true} placeholder="Select a category">
						<Select.Option value="car">Car</Select.Option>
						<Select.Option value="bike">Bike</Select.Option>
					</Select>
				</Form.Item>
				<Form.Item
					label="Starting Year"
					name="yearStart"
					rules={[{ required: true, message: 'Please input year!' }]}
					initialValue={generation?.yearStart}
				>
					<InputNumber />
				</Form.Item>
				<Form.Item label="Ending Year" name="yearEnd" initialValue={generation?.endYear}>
					<InputNumber />
				</Form.Item>
				<Form.Item
					label="Engine Type"
					name={['engine', 'type']}
					rules={[{ required: true, message: 'Please select engine type!' }]}
					initialValue={generation?.engine?.type}
				>
					<Select showSearch allowClear={true} placeholder="Select a engine type">
						<Select.Option value="cng">CNG</Select.Option>
						<Select.Option value="diesel">Diesel</Select.Option>
						<Select.Option value="electric">Electric</Select.Option>
						<Select.Option value="hybrid">Hybrid</Select.Option>
						<Select.Option value="petrol">Petrol</Select.Option>
					</Select>
				</Form.Item>
				<Form.Item
					label="Engine Capacity"
					name={['engine', 'size']}
					rules={[{ required: true, message: 'Please input engine capacity!' }]}
					initialValue={generation?.engine?.size}
				>
					<InputNumber />
				</Form.Item>
				<Form.Item
					label="Engine Horsepower"
					name={['engine', 'horsepower']}
					rules={[{ required: true, message: 'Please input engine horsepower!' }]}
					initialValue={generation?.engine?.horsepower}
				>
					<InputNumber />
				</Form.Item>
				<Form.Item
					label="Engine Average"
					name={['engine', 'average']}
					rules={[{ required: true, message: 'Please input engine average!' }]}
					initialValue={generation?.engine?.average}
				>
					<InputNumber />
				</Form.Item>
				<Form.Item {...tailLayout}>
					<Button type="primary" htmlType="submit">
						Update Trim
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};

export default EditGenerationForm;
